export type BreakProps = {};

export function Break(props: BreakProps) {
  return <hr className="my-6 border-2 border-backgroundgray" />;
}

export default Break;
